import { createCaseFirst } from './createCaseFirst';
/**
 * Переводит первый символ переданной строки в upper case.
 *
 * @param dataString Строка
 * @returns Строка с первым символом приведенным к upper case
 *
 * @example
 * ```typescript
 * import { upperFirst } from '@direct-frontend/stdlib';
 *
 * upperFirst('some text'); // 'Some text'
 * ```
 */
export const upperFirst = createCaseFirst('toUpperCase');
